import { StudyMethod } from './StudyMethod';
export default StudyMethod;
